import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, RowsSkeletonLoader } from '@node-space/ui-components'
import { RequestErrorStatusCard } from 'components/Errors/RequestErrorStatusCard'
import { SidePanelSection } from 'components/SidePanel/SidePanelSection'
import { MIN_PAGINATION_SIZE } from 'constants/queries'
import { CustomerApplicationDetails } from 'types/customers'
import { REQUIRED_ACTION_CODE_QUESTIONNAIRE_REQUIRED } from '../helpers/constants'

interface CustomerInfoRequiredProps {
  data: CustomerApplicationDetails | undefined
  isLoading: boolean
  isError: boolean
  refetch: () => void
}

export const CustomerInfoRequired = ({
  data,
  isLoading,
  isError,
  refetch,
}: CustomerInfoRequiredProps) => {
  const { t } = useTranslation()

  if (isLoading) {
    return <RowsSkeletonLoader rows={MIN_PAGINATION_SIZE} />
  }

  if (isError) {
    return (
      <Box paddingX={16} paddingY={32}>
        <RequestErrorStatusCard onReload={refetch} />
      </Box>
    )
  }

  const questionnaireActions = data?.requiredActions?.filter(
    action => action?.code === REQUIRED_ACTION_CODE_QUESTIONNAIRE_REQUIRED
  )

  return (
    <Box flexCol gapY={16} padding={16}>
      {!!questionnaireActions?.length && (
        <SidePanelSection heading={t('customers.infoRequired.details')}>
          <ul className="list-disc pl-5 text-body-regular-small">
            {questionnaireActions.map(action => (
              <li key={action.description}>
                {t(`customers.infoRequired.categories.${action.code}`, action.code)}
              </li>
            ))}
          </ul>
        </SidePanelSection>
      )}
    </Box>
  )
}
